import e, { useRef as n, useEffect as t } from "react";
import { Icon as r } from "../Icon/Icon.js";
import { componentName as i } from "../../../utils/bem/index.js";
import { ENTER as l, ESC as o } from "../../../constants/keyboard.js";
import { Spinner as a } from "../../loaders/Spinner/Spinner.js";
import c from "../../../../node_modules/classnames/index.js";
function s(e, n, t, r, i, l, o) {
  try {
    var a = e[l](o),
      c = a.value;
  } catch (e) {
    t(e);
    return;
  }
  a.done ? n(c) : Promise.resolve(c).then(r, i);
}
function u(u) {
  var p,
    d,
    f,
    b,
    y = u.children[0],
    m = u.children[1],
    g = n(null),
    v = function v(e) {
      u.onCancel(e), u.setEditing(!1);
    },
    h = (p = function p(e) {
      var n, t, r, i;
      return function (e, n) {
        var t,
          r,
          i,
          l,
          o = {
            label: 0,
            sent: function sent() {
              if (1 & i[0]) throw i[1];
              return i[1];
            },
            trys: [],
            ops: []
          };
        return l = {
          next: a(0),
          throw: a(1),
          return: a(2)
        }, "function" == typeof Symbol && (l[Symbol.iterator] = function () {
          return this;
        }), l;
        function a(l) {
          return function (a) {
            return function (l) {
              if (t) throw TypeError("Generator is already executing.");
              for (; o;) try {
                if (t = 1, r && (i = 2 & l[0] ? r.return : l[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, l[1])).done) return i;
                switch (r = 0, i && (l = [2 & l[0], i.value]), l[0]) {
                  case 0:
                  case 1:
                    i = l;
                    break;
                  case 4:
                    return o.label++, {
                      value: l[1],
                      done: !1
                    };
                  case 5:
                    o.label++, r = l[1], l = [0];
                    continue;
                  case 7:
                    l = o.ops.pop(), o.trys.pop();
                    continue;
                  default:
                    if (!(i = (i = o.trys).length > 0 && i[i.length - 1]) && (6 === l[0] || 2 === l[0])) {
                      o = 0;
                      continue;
                    }
                    if (3 === l[0] && (!i || l[1] > i[0] && l[1] < i[3])) {
                      o.label = l[1];
                      break;
                    }
                    if (6 === l[0] && o.label < i[1]) {
                      o.label = i[1], i = l;
                      break;
                    }
                    if (i && o.label < i[2]) {
                      o.label = i[2], o.ops.push(l);
                      break;
                    }
                    i[2] && o.ops.pop(), o.trys.pop();
                    continue;
                }
                l = n.call(e, o);
              } catch (e) {
                l = [6, e], r = 0;
              } finally {
                t = i = 0;
              }
              if (5 & l[0]) throw l[1];
              return {
                value: l[0] ? l[1] : void 0,
                done: !0
              };
            }([l, a]);
          };
        }
      }(this, function (l) {
        switch (l.label) {
          case 0:
            if (u.errorMessage) return [2];
            return null === (n = u.setIsApplying) || void 0 === n || n.call(u, !0), [4, u.onApply(e)];
          case 1:
            if (i = l.sent(), null === (t = u.setIsApplying) || void 0 === t || t.call(u, !1), (null == i ? void 0 : i.error) || u.errorMessage) return [2];
            return null === (r = u.setEditing) || void 0 === r || r.call(u, !1), [2];
        }
      });
    }, d = function d() {
      var e = this,
        n = arguments;
      return new Promise(function (t, r) {
        var i = p.apply(e, n);
        function l(e) {
          s(i, t, r, l, o, "next", e);
        }
        function o(e) {
          s(i, t, r, l, o, "throw", e);
        }
        l(void 0);
      });
    }, function (e) {
      return d.apply(this, arguments);
    });
  t(function () {
    var e, n;
    null == g || null === (n = g.current) || void 0 === n || null === (e = n.focus) || void 0 === e || e.call(n);
  }, [u.editing]);
  var E = i("inline-editor", u.className);
  return e.createElement("div", {
    onBlur: function onBlur(e) {
      e.currentTarget.contains(e.relatedTarget) || e.target === document.activeElement || u.disableBlur || h(e);
    },
    className: E
  }, u.editing ? e.createElement("div", {
    tabIndex: -1,
    className: "inline-editor__editable",
    onKeyDown: function onKeyDown(e) {
      switch (e.keyCode) {
        case o:
          u.cancelOnEsc && v(e);
          break;
        case l:
          u.applyOnEnter && h(e);
      }
    }
  }, e.createElement(m.type, (f = function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = null != arguments[n] ? arguments[n] : {},
        r = Object.keys(t);
      "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(t).filter(function (e) {
        return Object.getOwnPropertyDescriptor(t, e).enumerable;
      }))), r.forEach(function (n) {
        var r;
        r = t[n], n in e ? Object.defineProperty(e, n, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[n] = r;
      });
    }
    return e;
  }({}, m.props), b = b = {
    disabled: u.isApplying,
    ref: g
  }, Object.getOwnPropertyDescriptors ? Object.defineProperties(f, Object.getOwnPropertyDescriptors(b)) : function (e, n) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t.push.apply(t, r);
    }
    return t;
  }(Object(b)).forEach(function (e) {
    Object.defineProperty(f, e, Object.getOwnPropertyDescriptor(b, e));
  }), f)), u.isApplying && e.createElement(a, {
    className: "inline-editor__spinner"
  })) : e.createElement("div", {
    className: c("inline-editor__read-only", u.disableEditing && "inline-editor--edit-disabled"),
    onClick: function onClick() {
      var e;
      if (u.disableEditing) return !0;
      u.setEditing(!0), null === (e = u.onEdit) || void 0 === e || e.call(u);
    }
  }, y), u.editing && !u.isApplying && e.createElement("div", {
    className: "inline-editor__buttons"
  }, e.createElement("button", {
    type: "button",
    disabled: u.isApplying,
    onClick: h,
    className: "inline-editor__apply-button"
  }, e.createElement(r, {
    regular: !0,
    name: "check"
  })), e.createElement("button", {
    type: "button",
    disabled: u.isApplying,
    onClick: v,
    className: "inline-editor__cancel-button"
  }, e.createElement(r, {
    regular: !0,
    name: "times"
  }))));
}
u.defaultProps = {
  disableEditing: !1,
  cancelOnEsc: !0,
  applyOnEnter: !1,
  disableBlur: !1
};
export { u as InlineEditorStateless };